import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { id: "rateTableNew" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rate_table_filter = _resolveComponent("rate-table-filter")!
  const _component_animated_number = _resolveComponent("animated-number")!
  const _component_rate_table = _resolveComponent("rate-table")!
  const _component_rate_table_loader = _resolveComponent("rate-table-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass({'consumer-style': _ctx.isConsumer})
    }, [
      (_ctx.showFilters)
        ? (_openBlock(), _createBlock(_component_rate_table_filter, {
            key: 0,
            filter: _ctx.filter,
            isWp: _ctx.isConsumer,
            showDepositAmountAndEstEarning: _ctx.showDepositAmountAndEstEarning,
            showRegionFilter: _ctx.showRegionFilter,
            showAvailabilityFilter: _ctx.showAvailabilityFilter,
            showInstitutionFilter: _ctx.showInstitutionFilter
          }, null, 8, ["filter", "isWp", "showDepositAmountAndEstEarning", "showRegionFilter", "showAvailabilityFilter", "showInstitutionFilter"]))
        : _createCommentVNode("", true),
      _withDirectives(_createVNode(_component_rate_table, {
        filter: _ctx.filter,
        onDataLoaded: _ctx.rateTableDataLoaded,
        onRatetableResponse: _ctx.rateTableResponseCalled,
        isWp: _ctx.isConsumer,
        zoneKeys: _ctx.zoneKeys,
        labelCTAButton: _ctx.labelCtaButton,
        CTAButtonColor: _ctx.ctaButtonColor,
        showFilters: _ctx.showFilters,
        showDepositAmountAndEstEarning: _ctx.showDepositAmountAndEstEarning,
        showRegionFilter: _ctx.showRegionFilter,
        showResultsTable: _ctx.showResultsTableComputed,
        showAdCopy: _ctx.showAdCopy,
        frictionLevel: _ctx.frictionModal
      }, {
        "rate-table-title": _withCtx(() => [
          (_ctx.rateTableTitleText)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.rateTableTitleText), 1))
            : _renderSlot(_ctx.$slots, "rate-table-title", { key: 1 }, () => [
                _createVNode(_component_animated_number, {
                  number: _ctx.totalAccounts,
                  class: "resultsHeader"
                }, null, 8, ["number"]),
                _createTextVNode(" " + _toDisplayString(_ctx.totalAccounts > 1 ? 'Results' : 'Result'), 1)
              ])
        ]),
        _: 3
      }, 8, ["filter", "onDataLoaded", "onRatetableResponse", "isWp", "zoneKeys", "labelCTAButton", "CTAButtonColor", "showFilters", "showDepositAmountAndEstEarning", "showRegionFilter", "showResultsTable", "showAdCopy", "frictionLevel"]), [
        [_vShow, _ctx.hasData]
      ])
    ], 2), [
      [_vShow, _ctx.isLoaded]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_rate_table_loader, { showFilters: _ctx.showFilters }, null, 8, ["showFilters"])
    ], 512), [
      [_vShow, !_ctx.isLoaded]
    ])
  ]))
}